module.exports = __webpack_public_path__ + "static/img/9.74c676b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/zh/9.png
// module id = kzmz
// module chunks = 0